/**
 * @file
 */

import { CreateTHEADSectionGV } from "@/common/common.js";
import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

// Constants
const SHOWHIDE = 1;
const DISBURSMENTDATE = 2;
const LOANTYPE = 3;
const LOAN_TYPE = 4;
const LOAN_TYPE_RELATED = 5;
const BALANCEAMT = 6;
const INTERESTRATE = 7;
const DELINQUENTAMOUNT = 8;
const LATEFEEAMOUNT = 9;
const ACCRUEDINTERESTDATE = 10;
const ACCRUEDINTEREST = 11;
const LOANSTATUS = 12;
const GRACEENDDATE = 13;
const DEFERMENTDATE = 14;
const LOANNUMBER = 15;
const PAYOFFAMOUNT = 16;
const REBATE = 17;

export function InitializeEarlyPayoffCalculatorPage() {
   // --------------------------------------------------------------------------
   // initialize the validation engine
   // --------------------------------------------------------------------------
   var onSubmit = false;
   customValidationInit(onSubmit);
   aspControlValidationInit();

   // ----------------------------------------------------------------------------------------------
   // if a loan is clicked on the line item grid then hide the results and payment sections since
   // the payoff calculations will need to be re-done.
   //
   // Also handle the possibility that a related consolidation loan will need to be checked/unchecked
   // ----------------------------------------------------------------------------------------------
   $("[id*='chkSelect']").click(function (event) {
      hideResultsAndPayment();

      var rowSelected = $(this).closest("tr").index();

      checkRelatedConsolidationLoan(rowSelected);
   });

   // Select all checkbox
   $("[id$='chkAll']").click(function (event) {
     const checkBoxList = $("[id*='chkSelect']").filter("input:checkbox") as JQuery<HTMLInputElement>;
      if ($(this).is(":checked")) {
        checkBoxList.each(function () {
            this.checked = true;
         });
      } else {
        checkBoxList.each(function () {
            this.checked = false;
         });
      }

   });

  // create the thead section for the gridview since gridviews don't natively have it.
  CreateTHEADSectionGV("gvLoan");
  CreateTHEADSectionGV("gvVDLoan");

  var table = $('.responsiveTable').DataTable({
    "responsive": true,
    "scrollX": false,
    "paging": false,
    "searching": false,
    "ordering": false,
    "info": false,
    "columnDefs": [
      {
        target: 4,
        visible: false,
        searchable: false
      },
      {
        target: 5,
        visible: false,
        searchable: false
      },
      {
        target: 9,
        visible: false,
        searchable: false
      },
      {
        target: 10,
        visible: false,
        searchable: false
      },
      {
        target: 11,
        visible: false,
        searchable: false
      },
      {
        target: 12,
        visible: false,
        searchable: false
      },
      {
        target: 13,
        visible: false,
        searchable: false
      },
      {
        target: 14,
        visible: false,
        searchable: false
      },
      {
        target: 15,
        visible: false,
        searchable: false
      },
      {
        target: 16,
        visible: false,
        searchable: false
      },
      {
        target: 17,
        visible: false,
        searchable: false
      },
      {
        target: 18,
        visible: false,
        searchable: false
      },
      {
        target: 19,
        visible: false,
        searchable: false
      }
    ]
  });

// --------------------------------------------------------------------------------------------------
// We've received the Calendar custom event 'CalendarChange' so we need to hide the results and
// payment sections since the payoff calculations will need to be re-done.
// --------------------------------------------------------------------------------------------------
  $(document).on("CalendarChange", hideResultsAndPayment);

  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-09
  window.hideResultsAndPayment = hideResultsAndPayment;
};

// ---------------------------------------------------------------------------------------------------
// Hide all result and payment (mail, phone, and online) sections.  This is generally called because
// a change was made to the inputs of the payoff calculation (date, method, loans chosen for payoff)
// ---------------------------------------------------------------------------------------------------
function hideResultsAndPayment() {
   $("div[id$='divViewResults']").hide();
}

// ---------------------------------------------------------------------------------------------
// This function will determine if a consolidation loan was checked/unchecked.  If so
// it will do the same to it's related consolidation loans if present.  The borrower
// must pay off both subsidized and unsubsidized consolidation loans of certain types.
//
// Note:  If there are more than 2 consolidated loans that are related and of the same
// disbursement date then they all will be linked together.  For Example:  3 loans sequences
// with disbursement date 10/19/1998 and types of DLSCNS, DLUCNS, DLUCNS.  All three are treated
// as 1 selectable group.
// ---------------------------------------------------------------------------------------------
function checkRelatedConsolidationLoan(rowSelected: number) {
  const table = $("table[id$='gvLoan']") as JQuery<HTMLTableElement>;
  const tbody = table[0].tBodies[0];

  const relatedLoanType = tbody.rows[rowSelected].cells[LOAN_TYPE_RELATED].innerHTML;
  const currentLoanType = tbody.rows[rowSelected].cells[LOAN_TYPE].innerHTML;

  const checkBoxList = $("[id*='chkSelect']").filter("input:checkbox") as JQuery<HTMLInputElement>;
  const checkAll = $("[id$='chkAll']").filter("input:checkbox") as JQuery<HTMLInputElement>;
  const rowLen = tbody.rows.length;
  let checkCount = 0;

   if ((relatedLoanType !== "None") && (relatedLoanType !== "&nbsp;")) {
      const selectedDisbursementDate = tbody.rows[rowSelected].cells[DISBURSMENTDATE].innerHTML;
      const selectedCheckedState = checkBoxList[rowSelected].checked;

      for (let i = 0; i < rowLen; i++) {
         if (rowSelected !== i) {
           const indexLoanType = tbody.rows[i].cells[LOAN_TYPE].innerHTML;
           const currentDisbursementDate = tbody.rows[i].cells[DISBURSMENTDATE].innerHTML;
            if (((indexLoanType === relatedLoanType) || (indexLoanType === currentLoanType)) &&
               (currentDisbursementDate === selectedDisbursementDate)) {
               checkBoxList[i].checked = selectedCheckedState;
               if (selectedCheckedState == false) {
                  checkAll[0].checked = false;
               }
            }
         }
      }
   }

   // check to see if all the checkboxes have been checked.  If so then check the checkAll checkbox.
   for (let i = 0; i < rowLen; i++) {
      if (checkBoxList[i].checked) {
         checkCount = checkCount + 1;
      }
   }
   if (checkCount == rowLen) {
      checkAll[0].checked = true;
   } else {
      checkAll[0].checked = false;
   }

}
